<template>
  <fragment>
    <!-- 테이블 -->
    <PagingTable ref="table" :sourceList="tableItems">
      <template #header>
        <caption>
          <span class="blind">소식관리 목록</span>
        </caption>
        <colgroup>
          <col />
          <col />
          <col width="12%" />
          <col width="12%" />
        </colgroup>

        <thead class="table_list_head table_list_head_line">
          <tr>
            <th class="center">Round</th>
            <th class="center">회차</th>
            <th class="center sorting" data-sort="useDate">수행일자</th>
            <th class="center">기억건강 단계</th>
            <th class="center">정답수</th>
            <th class="center">1번</th>
            <th class="center">2번</th>
            <th class="center">3번</th>
            <th class="center">4번</th>
            <th class="center">5번</th>
            <th class="center">6번</th>
            <th class="center">7번</th>
            <th class="center">8번</th>
          </tr>
        </thead>
      </template>
      <template #row="{ rowData }">
        <tr>
          <td class="right">{{rowData.round}}</td>
          <td class="right">{{rowData.order}}</td>
          <td>{{rowData.useDate}}</td>
          <td>{{rowData.status}}</td>
          <td class="right">{{rowData.correctCount}}</td>
          <td class="right">{{rowData.number1}}</td>
          <td class="right">{{rowData.number2}}</td>
          <td class="right">{{rowData.number3}}</td>
          <td class="right">{{rowData.number4}}</td>
          <td class="right">{{rowData.number5}}</td>
          <td class="right">{{rowData.number6}}</td>
          <td class="right">{{rowData.number7}}</td>
          <td class="right">{{rowData.number8}}</td>
        </tr>
      </template>
    </PagingTable>

    <div class="section_button none_paginate">
      <ExcelDownloadButton :filename="$utils.excelName('대상자상세', '기억검사결과', rcpDetail.rcpName)">
        <ExcelTable :sourceList="tableItems" />
      </ExcelDownloadButton>
      <HelpButton contentId="HELP_07" />
    </div>
  </fragment>
</template>

<script>
import ExcelTable from "./Detail.dementia.excel";

export default {
  components: { ExcelTable },
  props: {
    rcpDetail: Object
  },
  data() {
    const rcpId = this.$route.params.id;
    return {
      rcpId,
      tableItems: null,
      formData: {
        rcpId
      }
    };
  },
  methods: {
    requestOptions() {
      return {
        params: this.formData
      };
    },
    loadData(keepTableState) {
      const options = this.requestOptions();
      this.$axios
        .get("/admin/happy/stats/v2/user/dementia", options)
        .then(({ data }) => {
          this.tableItems = data.userDementiaDataList;
          if (!keepTableState) this.$refs.table.resetState();
        });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style>
</style>